import { LegPosition, Strategy } from '@oai-frontend-monorepo/types';
import { TradierSymbolParser } from '../symbol/tradier-symbol/TradierSymbolParser';

type Params = {
  legs?: LegPosition[];
  strategy?: Strategy;
};

const parseExpirationFromLeg = ({ legs, strategy }: Params) => {
  if (!legs || !strategy) {
    return undefined;
  }

  if (strategy === Strategy.LONG_STOCK || strategy === Strategy.SHORT_STOCK) {
    return undefined;
  }

  return new TradierSymbolParser(legs[0].symbol).parsed?.expiration;
};

export default parseExpirationFromLeg;
